/**
 * Lane CQ-238 (the console value census X12, 2026-10-13: "Vim Invoice Search" on the Overview, Setup overview and Satori features vs
 * "Invoice search" on Business systems and in the conversation story) — ONE name per capability, console-wide.  The words are the
 * conversation story's own (`conversationDetail.story.tool.<snake_case>` in en.json — translated with the rest of the console); a
 * capability the console has no words for yet reads as the server's own title, else its id in plain words (never the raw token).
 * Pure (a translator in, words out); every capability name on a console surface goes through it (capabilityWords.cq238.test.js).
 */

/** "VimInvoiceSearch" / "vim-invoice-search" / "vim_invoice_search" → "vim_invoice_search" (the story's key form).  Pure. */
export function capabilityKeyOf(id) {
  return String(id ?? '').trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1_$2')
    .replace(/[\s.\-:/]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .toLowerCase();
}

/** "SearchPurchaseOrders" → "Search purchase orders" — the last resort for a capability without words (acronyms kept).  Pure. */
export function plainCapabilityWords(id) {
  if (!id) return '';
  const words = String(id)
    .replace(/[_\-.]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
    .trim()
    .split(/\s+/)
    .map((w) => (/^[A-Z0-9]{2,}$/.test(w) ? w : w.toLowerCase()));
  const s = words.join(' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

const MISSING = '\u0000capability-words-missing';

/** A capability in the console's words: the story's name for it, else the server's title (`title`), else its id in plain words. */
export function capabilityWords(t, id, title = null) {
  if (!id && !title) return '';
  const key = capabilityKeyOf(id);
  const named = key && typeof t === 'function' ? t(`conversationDetail.story.tool.${key}`, { defaultValue: MISSING }) : MISSING;
  if (named && named !== MISSING) return named;
  return (typeof title === 'string' && title.trim()) ? title.trim() : plainCapabilityWords(id);
}
